import React, { useMemo, useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap'
import Button from 'react-bootstrap/Button'
import Controllers from '../../Api/Controllers'
import Helpers from '../../Components/Helpers/Helpers'
import { toast } from 'react-toastify'
import Swal from 'sweetalert2'

export const VacationApprove = () => {
  const [isProcessing, setIsProccesing] = useState(true)
  const [reload, setReload] = useState(true)
  const [rows, setRows] = useState([])

  useEffect(() => {
    if (reload) {
      setIsProccesing(true)
      Controllers.vacation.get_all().then(res => {
        setRows(res.data || [])
      }).catch(req => Helpers.promise.catch({ req, toast }))
      .finally(() => {
        setIsProccesing(false)
        setReload(false)
      })
    }
  }, [reload])

  const handleApprove = async (row) => {
    const rowId = row.id_vacation
    const { value: formValues } = await Swal.fire({
      icon: 'question',
      title: '¿Desea aprobar las vacaciones?',
      html:
        `<p><strong>Trabajador</strong>: ${row.full_name_worker}</p>
                  <p><strong>Días Solicitados</strong>: ${row.vacation_days}</p>
                  <textarea id="swal-input-observation" class="swal2-textarea" rows="7" placeholder="Observación (opcional)"></textarea>`,
      showCancelButton: true,
      confirmButtonText: 'Aprobar',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      preConfirm: () => ({ observation: document.getElementById('swal-input-observation').value })
    });

    if (formValues) {
      try {
        Swal.fire({ title: 'Procesando...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        const response = await Controllers.vacation.approve({ p_id_vacation: rowId, p_comments: formValues.observation })
        Swal.close();
        Helpers.toast.construct({ ...response, toast });
      } catch (error) {
        Swal.close();
        Helpers.promise.catch({ req: error, toast });
      } finally {
        setReload(true);
      }
    }
  }

  const handleReject = async (row) => {
    const rowId = row.id_vacation
    const { value: formValues } = await Swal.fire({
      icon: 'warning',
      title: '¿Desea rechazar las vacaciones?',
      html:
        `<p><strong>Trabajador</strong>: ${row.full_name_worker}</p>
                  <p><strong>Días Solicitados</strong>: ${row.vacation_days}</p>
                  <textarea id="swal-input-observation" class="swal2-textarea" rows="7" placeholder="Observación (obligatoria)"></textarea>`,
      showCancelButton: true,
      confirmButtonText: 'Rechazar',
      cancelButtonText: 'Cancelar',
      focusConfirm: false,
      preConfirm: () => {
        const observation = document.getElementById('swal-input-observation').value.trim();
        if (!observation) {
          Swal.showValidationMessage('Debe ingresar una observación para rechazar');
          return false;
        }
        return { observation };
      },
    });

    if (formValues) {
      try {
        Swal.fire({ title: 'Procesando...', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
        const response = await Controllers.vacation.reject({ p_id_vacation: rowId, p_comments: formValues.observation })
        Swal.close();
        Helpers.toast.construct({ ...response, toast });
      } catch (error) {
        Swal.close();
        Helpers.promise.catch({ req: error, toast });
      } finally {
        setReload(true);
      }
    }
  }

  const dtRows = useMemo(() => <ReactDataTableBootstrap
    head={[[
      { name: 'full_name_worker', text: 'Trabajador', align: 'center' },
      { name: 'from_date', text: 'Fecha Inicio', align: 'center' },
      { name: 'to_date', text: 'Fecha Fin', align: 'center' },
      { name: 'vacation_days', text: 'Días', align: 'center' },
      { name: 'request_comments', text: 'Solicitud', align: 'center' },
      { name: 'status_vacation', text: 'Estado', align: 'center' },
      { name: 'comments', text: 'Comentarios', align: 'center' },
      { name: 'actions', text: <i className="fa fa-cog"></i>, align: 'center', render: u => {
        return <div>
          {u.status_vacation === 'PENDING' && <>
            <Button size="xs" variant="success" className="mr-1" onClick={() => handleApprove(u)}>
              <i className="fa fa-check"></i>
            </Button>
            <Button size="xs" variant="danger" onClick={() => handleReject(u)}>
              <i className="fa fa-times"></i>
            </Button>
          </>}
        </div>
      }},
    ]]}
    rows={rows}
    isProcessing={isProcessing}
  />, [rows, isProcessing])

  return <div className='form-row'>
    <div className="col-xl-2 col-lg-1"></div>
    <div className="col-xl-8 col-lg-10">
      <Card>
        <Card.Body>
          {dtRows}
        </Card.Body>
      </Card>
    </div>
  </div>
}

export default VacationApprove


